import { ProgramEngagement, ProgramEngagementModel } from '@cibo/core'
import { Loading, useWindowTitle } from '@cibo/profile'
import { PaginatedEngagementsTable, useProgram, useProgramEngagements } from '@cibo/programs'
import { ListCard, Markdown } from '@cibo/ui'
import { Box, Button, Stack } from '@mui/material'
import { GridRowParams } from '@mui/x-data-grid-pro'
import { EngagementImpossible } from 'components/EngagementImpossible'
import { PROGRAM_ROUTES } from 'navigation/types/routes'
import { useTranslation } from 'react-i18next'
import { Link, Navigate, generatePath, useNavigate, useParams } from 'react-router-dom'
import {
  ENGAGEMENT_PATHS,
  ENGAGEMENT_ROUTES,
} from '../../../../../navigation/types/engagementRoutes'

export const Engagements = () => {
  const { t } = useTranslation('impact/pages/Engagements')
  const { programId = '' } = useParams()
  const program = useProgram({ programId })
  useWindowTitle(program.data?.content.fields.title)
  const navigate = useNavigate()

  const engagements = useProgramEngagements({
    programId: [programId],
  })

  if (!engagements.isFetched || !program.isFetched) {
    return <Loading />
  }

  // no engagements, some eligible fields
  if (!engagements.data?.numItems) {
    if (
      !!program.data?.opportunitiesByWfStatus?.notInWorkflow &&
      !!program.data?.opportunitiesByWfStatus?.notInWorkflow[0]?.numResources
    ) {
      return (
        <Stack>
          <Box maxWidth={500}>
            <Markdown color="text.secondary">
              {t('eligibleFieldsCTAMd', { count: program.data.opportunities[0].numResources })}
            </Markdown>
          </Box>
          <Box>
            <Button
              variant="contained"
              color="secondary"
              size="large"
              component={Link}
              to={generatePath(PROGRAM_ROUTES.FIELDS_ELIGIBLE, { programId })}
            >
              {t('seeEligible')}
            </Button>
          </Box>
        </Stack>
      )
    } else {
      return program.data?.enrollmentWindow.enrollmentStatus === 'closed' ? (
        <Navigate to={generatePath(PROGRAM_ROUTES.ABOUT, { programId })} replace />
      ) : (
        <EngagementImpossible programId={programId} />
      )
    }
  }

  return (
    <ListCard
      title={t('programs')}
      subTitle={t('engagements', {
        context: program.data?.engageType,
        ns: 'impact/pages/ProgramV2DetailLayout',
      })}
    >
      <PaginatedEngagementsTable
        programId={programId}
        // @ts-ignore
        onRowClick={({ row }: GridRowParams<ProgramEngagement>) => {
          const engagement = new ProgramEngagementModel(row)
          const { id, programId } = row
          if (engagement.isComplete()) {
            const { step, stage } = engagement.lastStepAndStage()
            navigate(
              generatePath(`${PROGRAM_ROUTES.ENGAGEMENTS}/${ENGAGEMENT_ROUTES.STEP_STATUS}`, {
                programId,
                engagementId: id,
                stageId: stage.id,
                stepId: step.id,
              })
            )
          } else {
            navigate(
              generatePath(`${PROGRAM_ROUTES.ENGAGEMENTS}/${ENGAGEMENT_PATHS.ENGAGEMENT}`, {
                engagementId: id,
                programId,
              })
            )
          }
        }}
      />
    </ListCard>
  )
}
